import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import Row from 'react-bootstrap/lib/Row';
import Col from 'react-bootstrap/lib/Col';
import Button from 'react-bootstrap/lib/Button';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';

import ReviewItem from './ReviewItem';
import ReviewItemAboutYou from './ReviewItemAboutYou';
import Loader from '../Loader';

import messages from '../../locale/messages';

import noListImage from '/public/SiteImages/noReviewImage.svg';

import s from './Reviews.css';
import bt from '../../components/commonStyle.css';

const YourReviews = ({
  data: { loading, userReviews },
  loadMore,
  current,
  searchKey,
  isReviewLoading
}) => {
  let showLoadMore = userReviews?.results?.length > 0;

  return (
    <div>
      {loading && <Loader type="text" />}

      {!loading && (!userReviews || userReviews?.results?.length === 0) && (
        <div className={cx(s.textCenter, s.marginTop)}>
          <img src={noListImage} className={s.mobWidth} alt="No Reviews" />
          <div className={s.noListHeading}>
            <FormattedMessage {...messages.noReviewHeading} />
          </div>
          <div className={cx(s.noListSubHeading)}>
            <FormattedMessage {...messages.noReviewSubHeding} />
          </div>
        </div>
      )}

      {!loading && userReviews?.results?.length > 0 && (
        <div className={cx(s.panelNolist, s.spaceTop20, s.panelNolistBottom)}>
          <ul className={cx(s.listStyle, s.recommondations, 'listLayoutArbic')}>
            {userReviews.results.map((item, index) => {
              // Prevent Load More button if no more data
              showLoadMore = userReviews?.count === userReviews?.results?.length ? false : showLoadMore;

              if (current === 'notResponded') {
                return (
                  <ReviewItem
                    key={index}
                    reviewContent={item?.reviewContent}
                    createdAt={item?.createdAt}
                    isAdmin={item?.isAdmin}
                    picture={item?.authorData?.picture}
                    firstName={item?.authorData?.firstName}
                    lastName={item?.authorData?.lastName}
                    profileId={item?.authorData?.profileId}
                    rating={item?.rating}
                    listData={item?.listData}
                    listTitle={item?.singleReservationData?.listTitle}
                    current={current}
                    reservationId={item?.reservationId}
                  />
                );
              }

              if (current === 'responded') {
                return (
                  <ReviewItemAboutYou
                    key={index}
                    reviewContent={item?.reviewContent}
                    createdAt={item?.createdAt}
                    response={item?.response}
                    isAdmin={item?.isAdmin}
                    picture={item?.authorData?.picture}
                    firstName={item?.authorData?.firstName}
                    lastName={item?.authorData?.lastName}
                    profileId={item?.authorData?.profileId}
                    rating={item?.rating}
                    listData={item?.listData}
                    listTitle={item?.singleReservationData?.listTitle}
                    showReviewName={true}
                  />
                );
              }

              return null;
            })}
          </ul>
        </div>
      )}

      <Row>
        <Col lg={12} md={12} sm={12} xs={12} className={s.spaceBottom20}>
          {!loading && showLoadMore && userReviews?.results?.length > 0 && (
            <div className={cx(s.space2, s.textCenter, s.marginTop)}>
              <Button
                className={cx(s.btn, bt.btnPrimary, s.loadMoreBtn)}
                onClick={() => loadMore('others', current, searchKey)}
                disabled={isReviewLoading}
              >
                <FormattedMessage {...messages.loadMore} />...
              </Button>
            </div>
          )}
        </Col>
      </Row>
    </div>
  );
};

YourReviews.propTypes = {
  data: PropTypes.shape({
    loading: PropTypes.bool,
    userReviews: PropTypes.shape({
      results: PropTypes.array,
      count: PropTypes.number
    })
  }),
  loadMore: PropTypes.func.isRequired,
  current: PropTypes.string,
  searchKey: PropTypes.string,
  isReviewLoading: PropTypes.bool,
  intl: PropTypes.object.isRequired
};

export default injectIntl(withStyles(s, bt)(YourReviews));